import React from 'react';

import './Testimonials.css';

const testimonialsData = [
    {
        text: 'Their SEO expertise transformed our online presence. We went from page 5 to position 1 for our main keywords in just 6 months.',
        author: 'Sarah Johnson',
        position: 'CEO, TechStartup Inc.'
    },
    {
        text: 'The ROI on our Google Ads campaigns has been incredible. They truly understand how to optimize for conversions.',
        author: 'Michael Chen',
        position: 'Marketing Director, E-Commerce Co.'
    },
    {
        text: 'Professional, responsive, and results-driven. Our new website has increased conversions by 250% in the first quarter.',
        author: 'Emily Rodriguez',
        position: 'Founder, Creative Agency'
    }
];

const Testimonials = () => {
    return (
        <section className="testimonials">

            <div className="container">
                <div className="label">Client Success Stories</div>
                <h2>What Our Clients Say</h2>
                <div className="testimonials-grid">
                    {testimonialsData.map((testimonial, index) => (
                        <div className="testimonial-card" key={index}>
                            {/* IMAGE PLACEHOLDER: Add client photo or company logo here (recommended size: 80x80px) */}
                            <div className="testimonial-avatar">
                                <div className="testimonial-avatar-placeholder">
                                    <p>👤</p>
                                </div>
                            </div>
                            <p className="testimonial-text">"{testimonial.text}"</p>
                            <div className="testimonial-author">
                                <h4>{testimonial.author}</h4>
                                <p>{testimonial.position}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Testimonials;
